




































































































import Vue from 'vue';
import GetCallLogsRequestViewModel from '../../../../services/v1/viewModel/request/CallLogs/GetCallLogsRequestViewModel';
import ResponsePagingInfo from '../../../../plugins/servicelayer/responseTypes/responsePagingInfo';
import CallLogWithDurationResourceViewModel from '../../../../services/v1/viewModel/resource/CallLogWithDurationResourceViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    pagination: {} as ResponsePagingInfo,
    filter: {
      searchCriteria: undefined as string | undefined,
      correlationId: undefined as string | undefined,
      from: undefined as string | undefined,
      to: undefined as string | undefined,
      targetSystems: undefined as string[] | undefined,
      requestTypes: undefined as string[] | undefined,
      requestPath: undefined as string | undefined,
    },
    innerPagination: {
      'paging.CurrentPage': undefined as number | undefined,
      'paging.PageSize': undefined as number | undefined,
      'paging.IncludeCount': undefined as boolean | undefined,
      'paging.NoPaging': undefined as boolean | undefined,
    },
    callLogs: [] as CallLogWithDurationResourceViewModel[],
    columns: [] as {}[],
    targetSystems: [] as string[] | undefined,
    httpMethods: [] as any,
    isLoadingtargetSystems: false,
  }),
  computed: {
    request() {
      return new GetCallLogsRequestViewModel().fromModel({ ...this.filter, ...this.innerPagination });
    },
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.pagination.currentPage = 1;
        this.innerPagination['paging.CurrentPage'] = 1;
        this.$debounce(() => {
          this.refreshList();
        }, 300, this)();
      },
    },
    request() {
      this.writeRequestToQuery();
    },
  },
  beforeMount() {
    this.getQueryFromRequest();
    this.pagination.currentPage = this.innerPagination['paging.CurrentPage'] !;
    this.pagination.pageSize = this.innerPagination['paging.PageSize'] !;
  },
  mounted() {
    this.columns = [
      { value: '', field: 'filter' },
      { value: this.$t('core.page.callLog.list.id'), textAlign: 'left', field: 'id' },
      { value: this.$t('core.page.callLog.list.correlationId'), textAlign: 'left', field: 'correlationId' },
      { value: this.$t('core.page.callLog.list.appSystem'), textAlign: 'left', field: 'targetSystemName' },
      { value: this.$t('core.page.callLog.list.requestType'), textAlign: 'left', field: 'requestType' },
      { value: this.$t('core.page.callLog.list.requestPath'), textAlign: 'left', field: 'requestPath' },
      {
        value: this.$t('core.page.callLog.list.requestTime'), textAlign: 'left', field: 'requestTime', format: (value : any) => this.$date(value).format('DD.MM.YYYY HH:mm:ss:SSS'),
      },
      {
        value: this.$t('core.page.callLog.list.responseTime'), field: 'responseTime', format: (value : any) => this.$date(value).format('DD.MM.YYYY HH:mm:ss:SSS'),
      },
      { value: this.$t('core.page.callLog.list.responseDuration'), textAlign: 'right', field: 'responseDuration' },
      { value: this.$t('core.page.callLog.list.responseStatus'), textAlign: 'right', field: 'responseStatusCode' },
      { value: this.$t('core.page.callLog.list.message'), textAlign: 'left', field: 'responseInfo' },
    ];
    this.getTargetSystems();
    this.getHttpMethods();
  },
  methods: {
    getQueryFromRequest() {
      const queryParams = new GetCallLogsRequestViewModel();
      queryParams.fromQuery(this.$routerUtils.getQueryParams());
      this.filter.searchCriteria = queryParams.searchCriteria;
      this.filter.correlationId = queryParams.correlationId;
      this.filter.from = queryParams.from;
      this.filter.to = queryParams.to;
      this.filter.requestPath = queryParams.requestPath;
      this.filter.requestTypes = queryParams.requestTypes;
      this.filter.targetSystems = queryParams.targetSystems;

      this.innerPagination['paging.CurrentPage'] = queryParams['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = queryParams['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = queryParams['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = queryParams['paging.NoPaging'];
    },
    async writeRequestToQuery() {
      this.$debounce(() => {
        this.$routerUtils.updateQueryParams(this.request.toQuery(), { preserve: false });
      }, 200, this.writeRequestToQuery)();
    },
    refreshList() {
      const callLogList = this.$refs.callLogList as any;
      callLogList?.populateList();
    },
    async getCallLogs() {
      const response = await this.$service.api.core.callLogs.getCallLogs(this.request);
      this.callLogs = response.items;
    },
    populateData(params: any) {
      this.innerPagination['paging.CurrentPage'] = params.query['paging.CurrentPage'];
      this.innerPagination['paging.PageSize'] = params.query['paging.PageSize'];
      this.innerPagination['paging.IncludeCount'] = params.query['paging.IncludeCount'];
      this.innerPagination['paging.NoPaging'] = params.query['paging.NoPaging'];
      return this.$service.api.core.callLogs.getCallLogs(this.request);
    },
    async getTargetSystems() {
      this.isLoadingtargetSystems = true;
      const response = await this.$service.api.core.appSystem.getAppSystems();
      this.targetSystems = response.items.map((x) => x.name!);
      this.isLoadingtargetSystems = false;
    },
    async getHttpMethods() {
      const response = await this.$service.api.core.httpMethodLookup.lookupHttpMethods();
      this.httpMethods = response;
    },
    async clearFilters() {
      this.filter.searchCriteria = undefined;
      this.filter.correlationId = undefined;
      this.filter.from = undefined;
      this.filter.to = undefined;
      this.filter.requestPath = undefined;
      this.filter.requestTypes = undefined;
      this.filter.targetSystems = undefined;
    },
  },
});
